import NeptuneElement from '../../../NeptuneElement.js';

class StepperItem extends NeptuneElement {
    templateMarkup = `
        <li>               
            <div>
                <span></span> 
                <slot></slot>
            </div>
            <span></span>
        </li>
    `;
    componentCssUrl = '/src/components/core/stepper/stepperItem/stepper-item.css';

    static get observedAttributes() {
        return ['active', 'completed', 'error', 'data-step'];
    }

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.#updateState();
        this.#updateStepIndicator();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) return;
        this.#updateState();
        if (['active', 'completed', 'error', 'data-step'].includes(name)) {
            this.#updateStepIndicator();
        }
    }

    #updateState() {
        const li = this.shadowRoot?.querySelector('li');
        if (!li) return;
        li.classList.toggle('active', this.hasAttribute('active'));
        li.classList.toggle('error', this.hasAttribute('error'));
    }

    #updateStepIndicator() {
        const circle = this.shadowRoot?.querySelector('li > div > span:first-of-type');
        if (!circle) return;
        circle.textContent = '';
        if (!this.hasAttribute('completed')) {
            const stepNum = this.getAttribute('data-step');
            circle.textContent = stepNum || '';
        }
    }
}

customElements.define('neptune-stepper-item', StepperItem);
export default StepperItem;
